import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const patientDiagnosisService = {
  basePath: orgId => `${clinicalApiPath}/organizations/${orgId}/patient-diagnosis`,

  create(orgId, diagnosis) {
    return viperApi.post(this.basePath(orgId), diagnosis)
  },

  update(orgId, diagnosis) {
    return viperApi.put(this.basePath(orgId), diagnosis)
  },

  get(orgId, patientId, caseId) {
    let url = this.basePath(orgId) + `/${patientId}`
    if (caseId) url += `?caseId=${caseId}`
    return viperApi.get(url)
  },

  getFilters(orgId) {
    return viperApi.get(this.basePath(orgId) + '/filters')
  },

  delete(orgId, patientDiagnosisId) {
    return viperApi.delete(this.basePath(orgId) + `/${patientDiagnosisId}`)
  }
}
